<template>
    <div><!-- JQM 上傳 -->
        <CCard>
            <CCardBody>
                <div class="d-flex justify-content-end mb-2">
                    <button class="btn btn-sm btn-success"  v-if="canSave" @click="savedDataEvent(false)">{{$t('Buttons.SavedData')}}</button>
                    <button class="btn btn-sm btn-info ml-2"  v-if="canSave" @click="savedDataEvent(true)">{{$t('Buttons.SaveAndContinue')}}</button>
                    <button class="btn btn-sm btn-dark ml-2" @click="$router.go(-1)">{{$t('Buttons.GoBack')}}</button>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="title" :class="{enStatus: lang === 'en'}">{{ i18n("JQM.YearAndMonthAssigned") }}</div>
                        <div class="content">
                          <input :disabled="true" type="text" v-model="jqmUploadRow.jqmYearmonth">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="title" :class="{enStatus: lang === 'en'}">{{ i18n("JQM.WeekAssigned") }}&emsp;</div>
                        <div class="content">
                          <input :disabled="true" type="text" v-model="jqmUploadRow.jqmWeek">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="title" :class="{enStatus: lang === 'en'}">{{ i18n("JQM.YearAssigned") }}</div>
                        <div class="content">
                          <input :disabled="true" type="text" v-model="jqmUploadRow.jqmYear">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="title" :class="{enStatus: lang === 'en'}">{{ i18n("JQM.CreateDate") }}</div>
                        <div class="content">
                          {{fixDateTime(jqmUploadRow.jqmCreateDate)}}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="title requiredCss" style="width: 130px;" :class="{enStatus: lang === 'en'}">{{ i18n("JQM.GroupClassificationCode") }}</div>
                        <div class="content">
                            <table class="table table-bordered ">
                              <thead>
                                <tr>
                                  <th class="text-center col-md-4">{{ i18n("JQM.GroupClassificationCode") }}</th>
                                  <th class="text-center col-md-4">{{ i18n("JQM.GroupClassificationCodeChinese") }}</th>
                                  <th class="text-center col-md-4">{{ i18n("JQM.Upload") }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(it , index) in jqmDtlRows" :key="index">
                                  <td>
                                    <div class="input-form">                                       
                                      <Select2  style="width: 200px;" v-model="it.jqmDtlNum"
                                                :disabled="!canDelete || !isAddnew" 
                                                :options="matGrpListFilter(it)"                                                 
                                                @opening="onSelectOpening(it)"
                                                :settings="select2Setting()"                                                                                                 
                                                @select="numSelectEvent($event , it)"/>
                                                
                                      <button class="btn btn-sm btn-danger" v-if="isAddnew && canDelete" @click="clearJqmItem(it)">{{i18n('Buttons.Delete')}}</button>
                                    </div> 
                                  </td>
                                  <td class="text-center">{{it.jqmDtlName}}</td>
                                  <td>
                                    <div class="input-form">
                                        <input type="file" v-if="(isAddnew || it.jqmDtlNum) && isMember" style="width:300px;" @change="onFileSelection($event , it )"> 
                                        <span>{{ i18n("JQM.Uploaded") }}: </span>
                                        <a class="fileLink" v-if="showFileLink(it)" target="_blank" :href="getFileLink(it)">{{getFileName(it)}}</a>
                                    </div>
                                  </td>
                                </tr>                                
                              </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="title" :class="{enStatus: lang === 'en'}">{{ i18n("JQM.AuditDescription") }}</div>
                        <div class="content">
                            <textarea cols="10" maxlength="50" v-if="showConfirmUI" rows="5" v-model="jqmUploadRow.jqmMemo"></textarea>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="title" :class="{enStatus: lang === 'en'}">{{ i18n("JQM.Audit") }}&emsp;&emsp;</div>
                        <div class="content radio_container"  v-if="showConfirmUI">
                            <span v-for="(item, key) in rowStatusList" :key="'jqmRowStatus_input_' + key">
                                <input type="radio" :name="'jqm_RowStatusOpt'" v-model="jqmUploadRow.jqmStatus" :value="item.rowStatusId" >{{item.rowStatusCaption}}
                            </span>                      
                        </div>
                        <div class="content radio_container" v-else>{{jqmUploadRow.jqmStatusTxt}}</div>
                    </div>
                    <div class="col-md-12">
                        <table class="table table-bordered">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center">{{ i18n("JQM.LOGTime") }}</th> 
                                    <th class="text-center">{{ i18n("JQM.AuditDescription") }}</th> 
                                    <th class="text-center">{{ i18n("JQM.Status") }}</th> 
                                    <th class="text-center">{{ i18n("JQM.AssigneeOfUpdate") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item , index) in jqmLogRows" :key="index">
                                    <td class="text-center">{{fixDateTime(item.logDate)}}</td>
                                    <td class="text-center">{{item.logMemo}}</td>
                                    <td class="text-center">{{getJqmStatusTxt(item.logStatus)}}</td>
                                    <td class="text-center">{{item.logCreateusername}}</td>
                                </tr>                                
                            </tbody>
                        </table>
                    </div>
                </div>
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],
    data() {
        return {
            rowStatusList: this.$t('jqmStatusList'), //狀態 清單
            isReject : false,
            isAddnew : false,
            showConfirmUI : false,
            jqmUploadRow: {
              jqmDtlList: [],
              jqmLogList: []
            },
            jqmDtlRows : [],
            jqmLogRows : [],
            defaultMatGrpList : [],
            changeGpIndex: 1,
            currentItem : {}
        }
    },
    props : {
    },
    watch: {
        "lang": function() {
            this.rowStatusList = this.$t('jqmStatusList') //狀態 清單
        }
    },
    methods: {
        getDetail(guid) {//目前編輯的單筆 JQM 上傳 +明細內容清單        
            if('new' === guid){                
                this.isAddnew = true;                  
            }else{                
                this.isAddnew = false;                
            }
            const url = `${this.$apiUrl_Quality}/GetJQMUploadDetail/${guid}`
            this.updateLoading(true)
            this.axios.get(url).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功
                    const resultRow = response.data
                    if(resultRow.jqmStatus === 2){
                        this.isReject = true;
                    }else{
                        if(resultRow.jqmStatus === 1){
                            this.showConfirmUI = false; //完成
                        }
                        this.isReject = false;   
                    }
                    if(!this.isAddnew){
                        if(!this.isMember){
                            this.showConfirmUI = true;
                        }                        
                    }
                    if(resultRow.jqmDtlList){
                        this.jqmDtlRows = resultRow.jqmDtlList;
                    }else{
                        this.jqmDtlRows = [];                        
                    }
                    this.addFiveItems (this.jqmDtlRows)
                    if(resultRow.jqmLogList){
                        this.jqmLogRows = resultRow.jqmLogList;
                        resultRow.jqmLogList=null;
                    }
                    resultRow.jqmStatusTxt = this.jqmStatusMap[resultRow.jqmStatus];
                    this.jqmUploadRow = resultRow;
                    this.jqmUploadRow.oldJqmStatus = this.jqmUploadRow.jqmStatus;
                    if(this.canSave){
                        this.jqmUploadRow.jqmMemo = '';
                    }
                    this.updateLoading(false)
                }
            })
        },
        checkSaveData (){ //檢核必要儲存資料
            const chkRow= this.jqmUploadRow;
            if(this.isMember){
                chkRow.jqmMemo = ' ';
            }
            if(!chkRow.jqmMemo){
                this.$alert('審核說明為必要輸入資料！','警告',{type: 'warning'});
                return false;
            }
            if(!this.isMember && chkRow.jqmStatus === 0){
                this.$alert('審核狀態不得為待審核！','警告',{type: 'warning'});
                return false;
            }
            const chkDtlRows= this.jqmDtlRows;
            let okRowCount = 0;
            let hadError = false;
            let hadNoFile = false;
            chkDtlRows.forEach(r=> {
                if(r.jqmDtlNum && r.jqmDtlName){
                    okRowCount += 1;
                    if(!r.fileBase64){
                        hadNoFile = true;
                    }
                }else{
                    if(r.jqmDtlNum && !r.jqmDtlName ){
                        hadError = true;
                    }else if(!r.jqmDtlNum && r.jqmDtlName){
                        hadError = true;
                    }                    
                }
            });
            if(hadError){
                this.$alert('[分群碼] 資料必須同時都輸入！','警告',{type: 'warning'});
                return false;
            }
            if(this.isMember && hadNoFile){
                let msg;
                if(this.isAddnew){
                    msg = '[分群碼] 資料必須有對應的上傳檔案！';
                }else{
                    msg = '請更新檔案後再上傳！';
                }
                this.$alert(msg,'警告',{type: 'warning'});
                return false;
            }
            if(okRowCount === 0){
                this.$alert('[分群碼]至少要有一筆資料！','警告',{type: 'warning'});
                return false;
            }
            return true;
        },
        savedDataEvent (toContinue){
            if(!this.checkSaveData()) return;
            if(this.isAddnew || this.isReject){
                this.jqmUploadRow.jqmStatus = 0;
            }
            this.jqmUploadRow.jqmDtlList = this.jqmDtlRows;
            const url = `${this.$apiUrl_Quality}/UpdateJqmUploadRow`;
            const param = this.jqmUploadRow;
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功    
                    if(!toContinue){                
                      this.goBack();
                    }
                }                    
            }); 
        },
        onSelectOpening (it){
            this.currentItem = it;
        },
        matGrpListFilter (it){          
          if(it.grpList && this.changeGpIndex > 0){
            return it.grpList;
          }
          return [];
        },
        addFiveItems (list){
            if(list.length < 5){
              const lack = 5 - list.length;
               for(let k=0;k<lack;k++){
                 list.push({jqmDtlNum: '',jqmDtlName: '',});
               } 
            }
            for(let k=0;k<list.length;k++){
                const r = list[k];
                r.hadJqmDtlFile = r.jqmDtlFile;
                const grpList = [];
                if(r.jqmDtlNum && r.jqmDtlName){
                    grpList.push({id: r.jqmDtlNum , text:r.jqmDtlNum , wgbez : r.jqmDtlName});
                }
                r.grpList = grpList
            }
        },
        convertGpList (list ,srcList){
            let result =[];
            if(srcList){
                result = srcList;
                result.splice(0);
            }
            if(list && list.length >0){
                list.forEach(r=> {
                    result.push({id: r.matkl , text:r.matkl , wgbez : r.wgbez});
                });
            }
            return result;
        },
        numSelectEvent({id,wgbez} , it){
            it.jqmDtlNum =id;
            it.jqmDtlName = wgbez;
        },
        select2Setting (){
            const self =this;
            const setting = { 
                 multiple: false, 
                 dropdownAutoWidth : true , 
                 width: '100%' ,
                 ajax : self.ajaxSetting()
            };
            return setting;
        },
        ajaxSetting (){           
            const self =this;
            const baseUrl = `${this.$apiUrl_Quality}/GetMatGrpList`;                
            const ajaxObj = {
                url: baseUrl,
                transport: function (params, success) {
                    const keyword = params.data.term;
                    if(keyword && keyword.length >2){
                        const url = `${self.$apiUrl_Quality}/GetMatGrpList?keyword=${keyword}`;
                        self.axios.get(url).then((response) => {                    
                            const rows = self.convertGpList(response.data);                        
                            success(rows);                    
                        });      
                    }else{      
                        success(self.currentItem.grpList); 
                    }
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                }
            };
            return ajaxObj;
        },        
        clearJqmItem (it){
          it.jqmDtlNum ='';
          it.jqmDtlName ='';
          it.hadJqmDtlFile ='';
          it.jqmDtlFile ='';
        },
        getJqmStatusTxt(status){
            const map =this.jqmStatusMap;
            let v = map[status];
            if(v){
                return v;
            }
            return '';
        },        
        onFileSelection (e , it) { //--檔案挑選後，判斷並處理此檔案物件
            const maxFileByte = 5242880;            
            const acceptedImageTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/pdf'];
            // add all selected files
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return false;
            //const self = this;
            let file = files[0];
            let fileType = file['type'];
            let isAccpetType = acceptedImageTypes.includes(fileType);
            if (!isAccpetType) {
                e.target.value = '';
                this.$alert('檔案格式需為 Excel (Excel 2007 以上版本)/ PDF，請重新上傳!','警告',{type: 'warning'});
            } else if (maxFileByte < file.size) {
                e.target.value = '';
                this.$alert('檔案大小需5Mb以下，請重新上傳!','警告',{type: 'warning'});
            } else {                
                const reader = new FileReader();
                reader.readAsDataURL(file);                                 
                reader.onload = function(event) {
                    const itemBase64result = reader.result.substr(event.target.result.indexOf(',') + 1);
                    if(itemBase64result) {
                        it.jqmDtlFile = file.name;
                        it.fileBase64 = itemBase64result;
                    }
                };
            }
        },
        showFileLink (it){
            if(it.hadJqmDtlFile){
                return true;
            }
            return false;
        },
        getFileLink (it){
            const baseUrl = this.$apiUrl_Quality;
            const jqmGuid= this.jqmUploadRow.jqmGuid;
            if(it.hadJqmDtlFile){
                return `${baseUrl}/JqmDownload/${jqmGuid}/${it.jqmDtlGuid}`;
            }
        },
        getFileName (it){
            if(it.hadJqmDtlFile){
                return this.fixFileName(it.hadJqmDtlFile);
            }
            return '';
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        ...mapGetters(["lang"]),
        jqmStatusMap (){
            return this.listToMap(this.$t('jqmStatusList'), 'rowStatusId' ,'rowStatusCaption');
        },
        canEdit (){
            if(this.jqmUploadRow.oldJqmStatus && this.jqmUploadRow.oldJqmStatus === 1){
                return false;//已完成案件都不需處理
            }
            return (this.isAddnew || this.isReject) && this.isMember;
        },
        canDelete (){
            if(this.canSave && this.isMember){
                return true;
            }
            return false;
        },
        canSave (){
            if(this.jqmUploadRow.oldJqmStatus && this.jqmUploadRow.oldJqmStatus === 1){
                return false;//已完成案件都不需處理
            }
            if(this.isMember){
                return (this.isAddnew || this.isReject);
            }else{
                return true;
            }
        }
    },
    mounted() {        
        const self = this;
        const jqmGuid = sessionStorage.getItem('jqmGuid');
        if(jqmGuid){
            self.getDetail(jqmGuid);          
        }else{
            this.goBack();
        }
    },
    created() {
        
    }
}	
</script>
<style lang="scss" scoped>
.btn-edit {
    background-color: #343b55;
    color: white;
}

.row {
    padding: 0 12px;
}

.col-md-6 {
    display: flex;
    padding: 0;
    .content {
        flex: 1;

        input[type="radio"] {
            margin: 0 .5rem;
        }
    }

    .title, .content {
        display: flex;
        align-items: center;

        border: solid 1px;
        padding: .6rem 2rem;
    }

    textarea {
        width: 100%;
        margin: 0 .5rem;

        border-radius: 6px;
    }

    input {
      width: 100%;
      height: 35px;
      border-radius: 6px;
    }

    .title {
        background-color: #BDD6EE;
    }

    .radio_container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      span {
        width: 100%;
        display: flex;
        align-items: center;
      }

      input[type="radio"] {
        width: auto;
      }
    }
}

.col-md-12 {
    display: flex;
    padding: 0;

    .title, .content {
        display: flex;
        align-items: center;

        border: solid 1px;
        padding: .6rem 2rem;
    }

    .content {
        flex: 1;

        textarea {
            width: 100%;
            margin: 0 .5rem;
        }

        .table th {
            background-color: #fff;
            color: #000;
        }
    }

    .title {
        background-color: #BDD6EE;
    }

}

table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table, .table-bordered th, .table-bordered td {
    border-color: black;
}

.table th {
    // background-color: #FFC300;
    background-color: #FFD966;
    color: #000;
}

.table tr:nth-child(even) {
    background-color: transparent;
}

.input-form {
  display: flex;

  select, input {
    flex: 1;
  }

  select {
    height: 43px;
  }

  input[type=file] {
    height: 100%;
    // border: solid 1px black;
    // border-radius: 5px;
    // margin: 0 0.5rem;
    // padding: 0.5rem 0.2rem;
  }  
}
.requiredCss::before{
    content: "*";
    color: #f26161;
    font-weight: bolder;
    margin-bottom: 2px;
}
.enStatus {
    width: 200px !important;
}
</style>

